import { render } from "./TagManageModal.vue?vue&type=template&id=03c55cea&scoped=true"
import script from "./TagManageModal.vue?vue&type=script&lang=js"
export * from "./TagManageModal.vue?vue&type=script&lang=js"

import "./TagManageModal.vue?vue&type=style&index=0&id=03c55cea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c55cea"]])

export default __exports__